import { defineStore } from "pinia";
// 定义一个关于search的store
const searchInfoStore = defineStore("searchInfo", {

  state: () => ({
    searchValue:'', // 搜索关键字


  }),

  getters: { },

  // 类似methods
  actions: {
    setSearchValue(data) {
      this.searchValue = data
    },
    
  },

  persist: {
    storage: sessionStorage, //   sessionStorage localStorage
  },



}



);

export default searchInfoStore;
